import type { TranslationDictionary } from "./types";

export const FR_DICTIONARY: TranslationDictionary = {
    "app.newTask": "Nouveau",
    "app.newTaskAria": "Nouvelle discussion",
    "sidebar.searchPlaceholder": "Rechercher des invites ou une tâche ID",
    "sidebar.filters": "Filtres de tâches",
    "sidebar.allRatios": "Tous les ratios",
    "sidebar.allOrientations": "Toutes les orientations",
    "sidebar.allModes": "Tous les modes",
    "sidebar.allResolutions": "Toutes les résolutions",
    "sidebar.activeTasks": "Tâches actives",
    "sidebar.topAnchors": "Navigation dans le meilleur temps",
    "sidebar.bottomAnchors": "Navigation temporelle inférieure",
    "sidebar.resize": "Redimensionner la barre latérale",
    "batch.selected": "0 sélectionné",
    "batch.selectedCount": "{count} sélectionné",
    "batch.archivedCount": "Discussions {count} archivées",
    "batch.archiveFailed": "L'archivage par lots a échoué",
    "batch.runningCannotDeleteSelected": "Les discussions sélectionnées sont en cours et ne peuvent pas être supprimées",
    "batch.deleteTitle": "Supprimer les discussions {count}?",
    "batch.deleteMessage": "Cela supprimera également les fichiers image locaux.",
    "batch.deleteSkippedDetail": "{count} les tâches en cours seront conservées",
    "batch.deleteSkippedSuffix": ", {count} tâches en cours d'exécution non supprimées",
    "batch.deletedCount": "Chats {count} supprimés{skipped}",
    "batch.deleteFailed": "Échec de la suppression par lots",
    "action.archive": "Archiver",
    "action.delete": "Supprimer",
    "action.cancel": "Annuler",
    "action.edit": "Modifier",
    "action.clear": "Effacer",
    "action.paste": "Coller",
    "action.find": "Trouver",
    "action.replace": "Remplacer",
    "action.close": "Fermer",
    "action.confirm": "Confirmer",
    "action.confirmQuestion": "Confirmer l'action?",
    "action.refresh": "Actualiser",
    "action.save": "Enregistrer",
    "action.add": "Ajouter",
    "action.new": "Nouveau",
    "action.import": "Importer",
    "action.export": "Exporter",
    "queue.empty": "Pas de file d'attente",
    "queue.emptyAria": "Statut de la file d'attente: aucune tâche en file d'attente",
    "queue.jumpTitle": "Accéder aux tâches actives",
    "queue.emptyTitle": "Aucune tâche en file d'attente",
    "queue.channel": "Canaux {count}",
    "queue.availableChannels": "Canaux disponibles {usable}/{total}",
    "queue.dispatching": "Planification · attente {waiting}",
    "queue.runningWaiting": "En cours d'exécution {running} · en attente {waiting}",
    "queue.statusLabel": "État de la file d'attente: {text} · {channelText}. Cliquez pour accéder aux tâches actives",
    "queue.runningActions": "Exécuter des actions de file d'attente de tâches",
    "queue.waitingActions": "Actions de la file d'attente des tâches en attente",
    "queue.cancelRunning": "Annuler",
    "queue.cancelRunningTitle": "Annuler la tâche en cours",
    "queue.dragWaiting": "Faites glisser pour réorganiser la tâche en attente",
    "queue.dragSort": "Faites glisser pour trier",
    "queue.moveUp": "Vers le haut",
    "queue.moveUpTitle": "Déplacer la tâche en attente vers le haut",
    "queue.moveDown": "Vers le bas",
    "queue.moveDownTitle": "Déplacer la tâche en attente vers le bas",
    "queue.promote": "Haut",
    "queue.promoteTitle": "Déplacer la tâche en attente vers le haut",
    "queue.promoteFailed": "Échec du déplacement vers le haut",
    "queue.deleteWaitingShort": "Del",
    "queue.deleteWaitingTitle": "Supprimer la tâche en attente",
    "queue.deleteWaitingTitleConfirm": "Supprimer la tâche en attente?",
    "queue.deleteWaitingMessage": "Cela le supprime de la file d'attente et de la liste de l'historique.",
    "queue.deleteQueuedFailed": "Échec de la suppression de la tâche en file d'attente",
    "queue.queuedDeleted": "Tâche en file d'attente supprimée",
    "queue.cancelRunningConfirm": "Annuler la tâche",
    "queue.cancelRunningTitleConfirm": "Annuler la tâche en cours?",
    "queue.cancelRunningMessage": "La tâche en cours s'arrêtera. L'histoire sera conservée.",
    "queue.cancelRunningFailed": "Échec de l'annulation de la tâche",
    "queue.runningCancelled": "Tâche annulée",
    "queue.reorderFailed": "Échec de la réorganisation de la file d'attente",
    "queue.realtimeUpdateFailed": "Échec de la mise à jour du statut en direct",
    "queue.realtimeDisconnected": "La connexion avec l'état en direct a été perdue. Actualisez la page pour récupérer.",
    "queue.readFailed": "Échec du chargement de la file d'attente",
    "status.waiting": "En attente",
    "status.shownActiveTasks": "Afficher les tâches actives",
    "status.jsonCopied": "JSON copié",
    "taskStatus.submitting": "Soumission",
    "taskStatus.running": "Génération",
    "taskStatus.runningWithElapsed": "Génération · {elapsed}",
    "taskStatus.completed": "Terminé",
    "taskStatus.partialFailed": "Partiellement échoué",
    "taskStatus.failed": "Échec",
    "taskStatus.queued": "En file d'attente",
    "taskStatus.unknown": "Statut inconnu",
    "taskStatus.task": "Tâche",
    "taskStatus.connectionInterrupted": "Connexion interrompue",
    "taskStatus.lastFailed": "Dernier échec",
    "taskStatus.waitingRetry": "{reason}, en attente de nouvelle tentative (tentative {attempt}/{max})",
    "taskStatus.retrying": "{reason}, nouvelle tentative (tentative {attempt}/{max})",
    "taskStatus.nonRetryableAttempt": "Tentative {attempt}/{max}, non réessayable",
    "taskStatus.manualRetryAvailable": "Arrêté; les images ayant échoué peuvent être réessayées manuellement",
    "taskStatus.waitingRetryShort": "En attente",
    "taskStatus.retryingShort": "Nouvel essai",
    "taskStatus.nonRetryableShort": "Non réessayable",
    "taskStatus.manualRetryShort": "Réessai manuel",
    "taskStatus.stoppedShort": "Arrêté",
    "taskStatus.runtime": "Durée {duration}",
    "taskStatus.runtimeCompleted": "Durée {duration} · complété {time}",
    "taskStatus.completedAt": "Terminé {time}",
    "taskCard.count": "Images {count}",
    "taskCard.successCount": "réussi {count}",
    "taskCard.failedCount": "échec {count}",
    "taskCard.runningCount": "générer {count}",
    "taskCard.waitingCount": "en attente {count}",
    "taskCard.textToImageThumb": "Miniature de la tâche de conversion texte-image",
    "taskCard.imageToImageThumb": "Vignette de la tâche image à image",
    "taskCard.failedThumb": "La tâche a échoué",
    "taskCard.textBadge": "T",
    "taskMode.edit": "Modifier",
    "taskMode.generate": "Générer",
    "document.generatingQueue": "Génération · file d'attente {total}",
    "document.queuedWaiting": "En file d'attente · en attente {count}",
    "runFeedback.editing": "Édition",
    "runFeedback.generating": "Génération",
    "runFeedback.status": "{action}, écoulé {elapsed}",
    "footer.archive": "Archiver",
    "footer.archiveCount": "Archiver {count}",
    "footer.historyLibrary": "Histoire",
    "historyLibrary.openFull": "Ouvrir la bibliothèque d'historique complète",
    "history.documentTitle": "Histoire - 阿泰生图",
    "history.back": "Retour au générateur",
    "history.title": "Histoire",
    "history.loading": "Chargement",
    "history.total": "{total} tâches · {archived} archivé",
    "history.search": "Rechercher",
    "history.searchPlaceholder": "Rechercher des invites ou une tâche ID",
    "history.clear": "Effacer",
    "history.type": "Type",
    "history.allTypes": "Tous les types",
    "history.type.textToImage": "Texte vers image",
    "history.type.imageToImage": "Image vers image",
    "history.month": "Mois",
    "history.status": "Statut",
    "history.promptMode": "Traitement du prompt",
    "history.size": "Taille",
    "history.quality": "Qualité",
    "history.ratio": "Rapport",
    "history.orientation": "Orientation",
    "history.backend": "Back-end",
    "history.provider": "Fournisseur",
    "history.archived": "Archivé",
    "history.all": "Tout",
    "history.allMonths": "Tous les mois",
    "history.allStatuses": "Tous les statuts",
    "history.allPromptModes": "Tous les modes",
    "history.allSizes": "Toutes tailles",
    "history.allQualities": "Toutes les qualités",
    "history.allRatios": "Tous les ratios",
    "history.ratioOther": "Autre",
    "history.allOrientations": "Toutes les orientations",
    "history.allBackends": "Tous les back-ends",
    "history.allProviders": "Tous les fournisseurs",
    "history.unarchived": "Désarchivé",
    "history.archivedOnly": "Archivé",
    "history.tasksAria": "Tâches historiques",
    "history.taskListTitle": "Tâches historiques",
    "history.browseNewest": "Parcourir les plus récents en premier",
    "history.view": "Voir",
    "history.grid": "Grille",
    "history.list": "Liste",
    "history.sort": "Trier",
    "history.newest": "Le plus récent en premier",
    "history.oldest": "Le plus ancien en premier",
    "history.refresh": "Actualiser",
    "history.selectedCount": "{count} tâches sélectionnées",
    "history.confirmDelete": "Confirmer la suppression",
    "history.detail": "Détail de la tâche",
    "history.detailTitle": "Tâche d'historique",
    "history.closeDetail": "Fermer le détail de la tâche",
    "history.resizeFilters": "Redimensionner la barre latérale du filtre",
    "history.resizeDetail": "Redimensionner le volet de détails",
    "history.detailEmpty": "Sélectionnez une tâche historique pour afficher les détails",
    "history.loadingDetail": "Chargement des détails...",
    "history.loadMore": "Charger plus",
    "history.loadingMore": "Chargement...",
    "history.noMore": "Plus de tâches",
    "history.loadFailed": "Le chargement a échoué. Actualisez ou continuez à faire défiler pour réessayer",
    "history.summaryFailed": "Échec du chargement du résumé",
    "history.tasksFailed": "Échec du chargement des tâches",
    "history.detailFailed": "Échec du chargement des détails",
    "history.noMatches": "Aucune tâche correspondante",
    "history.loadedCount": "{count} chargé",
    "history.windowNotice": "La liste montée est limitée aux tâches {count}; faites défiler vers le haut ou vers le bas pour restaurer les tâches adjacentes à la demande.",
    "history.selectTask": "Sélectionnez une tâche",
    "history.viewing": "Affichage",
    "history.noPreview": "Aucune image d'aperçu",
    "history.downloadAll": "Télécharger ZIP",
    "history.downloadImage": "Télécharger l’image",
    "history.downloadSelected": "Télécharger sélectionné",
    "history.deleteUnselected": "Supprimer les éléments non sélectionnés",
    "history.confirmDeleteUnselected": "Confirmer la suppression désélectionnée",
    "history.selected": "Sélectionné",
    "history.select": "Sélectionnez",
    "history.downloadIndex": "Télécharger {index}",
    "history.addReference": "Ajouter une référence",
    "history.outputActions": "Actions sur l'image de résultat",
    "history.inputReferences": "Références d'entrée",
    "history.inputReferenceIndex": "Référence d'entrée {index}",
    "history.copyPrompt": "Copier l'invite",
    "history.copyPrompts": "Copier les invites",
    "history.copyPromptShort": "Copier",
    "history.copyPromptPanel": "Copier {title}",
    "history.copyOutputPromptPanel": "Copier l'image {index} invite révisée",
    "history.copyTaskIds": "Copier la tâche IDs",
    "history.reuseTask": "Afficher dans le générateur",
    "history.downloadTask": "Télécharger",
    "history.downloadSelectedTasks": "Téléchargement par lots",
    "history.contextMenuLabel": "Menu contextuel des tâches d'historique",
    "history.promptCopied": "Invite copiée",
    "history.promptsCopied": "Invites copiées des tâches {count}",
    "history.taskIdsCopied": "Tâche {count} copiée IDs",
    "history.promptCopiedShort": "Copié",
    "history.promptCopyFailed": "Échec de la copie de l'invite",
    "history.promptCopyFailedShort": "Échec",
    "history.noPrompt": "Cette tâche n'est pas invitée à copier",
    "history.noPromptShort": "Vide",
    "history.downloadStarted": "Téléchargement commencé",
    "history.batchDownloadStarted": "Téléchargements démarrés pour les tâches {count}",
    "history.noDownloadableOutputs": "Aucune image téléchargeable",
    "history.confirmDeleteSelected": "Confirmer la suppression sélectionnée",
    "history.openPreview": "Ouvrir l'aperçu",
    "history.closePreview": "Fermer l'aperçu",
    "history.untitled": "Sans titre",
    "history.promptCompare": "Comparaison rapide",
    "history.promptOriginal": "Invite d'origine",
    "history.promptSubmitted": "Invite optimisée",
    "history.promptRevised": "Résultat révisé",
    "history.outputRevisedPromptTitle": "Image {index} invite révisée",
    "history.outputRevisedPromptNotice": "Chaque image a sa propre invite révisée sous l'image.",
    "history.promptEmpty": "Aucun contenu",
    "history.promptMode.strict": "Fidèle",
    "history.promptMode.original": "Original",
    "history.promptMode.off": "Automatique",
    "history.quality.high": "Élevé",
    "history.quality.medium": "Moyen",
    "history.quality.low": "Faible",
    "history.quality.auto": "Automatique",
    "footer.batch": "Lot",
    "footer.storage": "Stockage",
    "footer.apiStatus": "Statut API: OK",
    "footer.version": "Version {version}",
    "footer.versionInfo": "Informations sur la version",
    "footer.versionLoading": "Version...",
    "footer.updateBadge": "Nouvelle version disponible",
    "footer.updateAvailable": "Nouvelle version {version}",
    "version.title": "Version et mise à jour",
    "version.loading": "Lecture de l'état de la version",
    "version.current": "Version actuelle",
    "version.latest": "Dernière version",
    "version.source": "Durée d'exécution",
    "version.sourcePortable": "Forfait portable",
    "version.sourceStandard": "Standard app",
    "version.sourceSource": "Récupération de la source",
    "version.upToDate": "Vous êtes déjà sur la dernière version",
    "version.updateAvailable": "La version {version} est disponible. Fermez la fenêtre du serveur WebUI, puis exécutez le programme de mise à jour pour effectuer la mise à niveau.",
    "version.standardUpdateAvailable": "Version {version} is available. Updater-enabled macOS standard apps can install it from Check for Updates in the menu bar; this link remains the manual fallback.",
    "version.standardManualInstall": "Updater-enabled macOS standard apps support user-confirmed replacement; older macOS apps and Windows standard ZIP packages still update manually.",
    "version.noUpdater": "Ce runtime n'est pas un package portable, le programme de mise à jour ne peut donc pas être démarré automatiquement.",
    "version.openUpdater": "Démarrer le programme de mise à jour",
    "version.release": "Voir la version",
    "version.updaterStarted": "Le programme de mise à jour a démarré. Fermez la fenêtre actuelle du serveur WebUI, puis suivez les invites du programme de mise à jour.",
    "version.updaterFailed": "Impossible de démarrer le programme de mise à jour. Exécutez manuellement le script de mise à jour à partir du package.",
    "version.historyTitle": "Nouveautés",
    "version.historyEmpty": "Aucune note de version disponible",
    "version.currentBadge": "Actuelle",
    "version.releaseDate": "{date}",
    "version.change.quick_gallery_picker": "Added a quick gallery modal picker with real-time search, multi-selection, and thumbnail optimizations.",
    "version.change.official_asset_library": "La bibliothèque officielle de logos, slogans et signatures commerciales a été enrichie avec davantage de marques, de lignes métier, de formats horizontaux et verticaux et de variantes inversées.",
    "version.change.material_picker_modal": "Le sélecteur de médias devient une fenêtre avec grands aperçus, catégories, recherche et sélection multiple.",
    "version.change.brand_name": "Le nom du produit est désormais AI Innovation Studio dans toutes les langues.",
    "version.change.brand_templates": "Ajout de modèles de marque sélectionnables et de la composition automatique des logos, slogans et autres éléments.",
    "version.change.brand_preview": "Les résultats de marque restent cohérents dans l’aperçu, l’historique, le zoom et le téléchargement, avec accès à l’image d’origine.",
    "version.change.mobile_workspace": "Compression de l’en-tête mobile, de la barre d’action, du résumé des éléments et de l’aperçu vide.",
    "version.change.task_center": "Compression du centre de tâches mobile et ajout d’un badge pour les tâches actives et en attente.",
    "version.change.brand_launch": "Lancement de l’expérience mobile de marque avec les ressources visuelles Hengtai.",
    "version.change.core_workflow": "Mise en place du flux principal de génération, file d’attente, historique, galerie et réglages.",
    "notifications.title": "Notifications",
    "notifications.unread": "Notifications, {count} non lues",
    "notifications.unreadSummary": "{count} non lu",
    "notifications.empty": "Aucune notification de tâche",
    "notifications.taskFailed": "La tâche a échoué",
    "notifications.taskPartial": "Tâche partiellement terminée",
    "notifications.taskCompleted": "Tâche terminée",
    "notifications.generationFailed": "La génération a échoué",
    "notifications.successCount": "{count} a réussi",
    "notifications.resultAvailable": "Résultats disponibles",
    "notifications.failedCount": "{count} a échoué",
    "notifications.systemUnsupported": "Ce navigateur ne prend pas en charge les notifications système",
    "notifications.systemBlocked": "Les notifications système sont bloquées par le navigateur. Activez-les dans les paramètres du navigateur.",
    "notifications.systemDenied": "Les notifications système ne sont pas activées",
    "notifications.systemEnabled": "Notifications système activées",
    "notifications.taskMissing": "La tâche n'existe pas ou a été supprimée",
    "theme.label": "Thème",
    "theme.system": "Automatique",
    "theme.light": "Clair",
    "theme.dark": "Sombre",
    "language.label": "Langue de l'interface",
    "language.zh": "中",
    "language.zhCN": "简体中文",
    "language.zhTW": "正體中文",
    "language.zhHK": "繁体中文",
    "language.ja": "日本語",
    "language.ko": "한국어",
    "language.en": "English",
    "language.es": "Español",
    "language.pt": "Português",
    "language.fr": "Français",
    "language.de": "Deutsch",
    "language.ru": "Русский",
    "language.it": "Italiano",
    "language.hi": "हिन्दी",
    "auth.label": "Source d'authentification",
    "auth.checking": "Vérification de l'authentification",
    "auth.missingCodexSession": "Aucune session Codex détectée",
    "auth.switchFailed": "Échec du changement de source d'authentification",
    "auth.sourceUnavailable": "{source} indisponible",
    "auth.notActive": "Pas actif",
    "api.settings": "Paramètres système",
    "api.provider": "Fournisseur API",
    "imageInput.title": "Images",
    "imageInput.uploadAria": "Cliquez, déposez ou collez des images et des fichiers",
    "imageInput.uploadFull": "Cliquez, déposez ou collez des images et des fichiers",
    "imageInput.uploadCompact": "Ajouter une entrée",
    "imageInput.uploadSubtitle": "Images et fichiers de référence pour Responses",
    "imageInput.recent": "Téléchargements récents",
    "imageInput.recentBadge": "Récent",
    "imageInput.uploadBadge": "Télécharger",
    "imageInput.addToGallery": "Ajouter à la galerie",
    "imageInput.addToGalleryShort": "Galerie",
    "imageInput.removeImage": "Supprimer l'image",
    "imageInput.editedBadge": "Modifié",
    "imageInput.editImage": "Modifier {name}",
    "imageInput.deletedRecent": "Téléchargement récent supprimé",
    "imageInput.deletedGallery": "Image de la galerie supprimée",
    "recentAssets.defaultName": "Téléchargement récent",
    "recentAssets.use": "Utilisez {name}",
    "recentAssets.delete": "Supprimer {name}",
    "recentAssets.deleteTitle": "Supprimer le téléchargement récent?",
    "recentAssets.deleteMessage": "Cela supprimera l'image des téléchargements récents. S'il est actuellement sélectionné comme entrée d'image, il sera supprimé de l'entrée actuelle. Les tâches historiques qui font référence à ce téléchargement récent perdront cet aperçu d’entrée. La galerie publique n’est pas concernée.",
    "recentAssets.loadFailed": "Échec du chargement des téléchargements récents",
    "recentAssets.deleteFailed": "Échec de la suppression du téléchargement récent",
    "recentAssets.deleted": "Téléchargement récent supprimé",
    "inputSource.uploadFallback": "Image téléchargée",
    "inputSource.galleryFallback": "Image de la galerie",
    "inputSource.focusPasteFallback": "{prefix}. L'entrée d'image est ciblée; appuyez sur {shortcut} pour coller des images.",
    "inputSource.pastedCount": "Images du presse-papiers {count} collées",
    "inputSource.droppedCount": "Ajout des images supprimées {count}",
    "inputSource.dropImagesOnly": "Supprimer uniquement les fichiers image",
    "inputSource.clipboardUnsupported": "Ce navigateur ne peut pas lire directement le presse-papiers",
    "inputSource.clipboardEmpty": "Aucune image du presse-papiers trouvée",
    "inputSource.clipboardDenied": "Le navigateur a bloqué l'accès direct au presse-papiers",
    "inputSource.clipboardReadFailed": "Échec de la lecture du presse-papiers",
    "status.missingGalleryReference": "Une image de référence de la galerie a été supprimée. Supprimez-le avant de générer.",
    "status.missingRecentReference": "Une image de référence téléchargée récemment a été supprimée. Supprimez-le avant de générer.",
    "status.emptyPrompt": "Entrez une invite",
    "status.editNeedsImage": "Le mode édition nécessite au moins une image",
    "status.loadedTask": "Tâche chargée {taskId}",
    "status.reusedTask": "Tâche ouverte {taskId} dans le générateur",
    "status.loadingHistoryInputs": "Chargement des images d'entrée historiques...",
    "status.historyInputLoadFailed": "Échec du chargement de l'image d'entrée historique: {url}",
    "referenceCollector.alreadyStaged": "Déjà mis en scène comme référence",
    "referenceCollector.staged": "Images de référence {count} mises en scène",
    "referenceCollector.title": "Références en attente · {count}",
    "referenceCollector.addAll": "Ajouter toutes les références",
    "referenceCollector.itemFallback": "Référence en attente",
    "referenceCollector.remove": "Supprimer la référence en attente",
    "referenceCollector.cleared": "Références en attente effacées",
    "referenceCollector.added": "Ajout d'images de référence {count}",
    "referenceCollector.addFailed": "Échec de l'ajout de références en attente",
    "referenceCollector.readFailed": "Échec de la lecture de l'image: {status}",
    "gallery.quick": "Galerie rapide",
    "gallery.current": "Galerie des catégories actuelles",
    "gallery.categories": "Catégories de la galerie",
    "gallery.categoryPortrait": "Portrait",
    "gallery.categoryCharacter": "Caractère",
    "gallery.categoryProduct": "Produit",
    "gallery.categoryPortraitRole": "Référence de portrait",
    "gallery.categoryCharacterRole": "Référence du personnage",
    "gallery.categoryProductRole": "Référence produit",
    "gallery.referenceRole": "Image de référence",
    "gallery.manage": "Gérer la galerie",
    "gallery.loadFailed": "Échec du chargement de la galerie",
    "gallery.imageOrderUpdateFailed": "Échec de la mise à jour de l'ordre des images",
    "gallery.imageOrderUpdated": "Ordre des images mis à jour",
    "gallery.categoryName": "Nom de la catégorie",
    "gallery.categoryPromptRole": "Rôle d'invite",
    "gallery.categorySave": "Enregistrer",
    "gallery.categoryDelete": "Supprimer",
    "gallery.categoryLoadFailed": "Échec du chargement des catégories",
    "gallery.categoryNameRequired": "Entrez un nom de catégorie",
    "gallery.categoryCreateFailed": "Échec de l'ajout d'une catégorie",
    "gallery.categoryCreated": "Catégorie ajoutée",
    "gallery.categorySaveFailed": "Échec de l'enregistrement de la catégorie",
    "gallery.categorySaved": "Catégorie enregistrée",
    "gallery.categoryDeleteTitle": "Supprimer la catégorie de la galerie?",
    "gallery.categoryDeleteMessage": "Les images de cette catégorie seront déplacées vers une autre catégorie. Les images de la galerie ne seront pas supprimées.",
    "gallery.categoryDeleteConfirm": "Supprimer la catégorie",
    "gallery.categoryDeleteFailed": "Échec de la suppression de la catégorie",
    "gallery.categoryDeletedMigrated": "Catégorie \"{name}\" supprimée et images migrées",
    "gallery.categoryOrderUpdateFailed": "Échec de la mise à jour de l'ordre des catégories",
    "gallery.categoryOrderUpdated": "Ordre des catégories mis à jour",
    "gallery.categoryFallback": "Catégorie Galerie",
    "gallery.imageFallback": "Image de la galerie",
    "gallery.imageLoadFailed": "Échec du chargement de cette image",
    "gallery.editImageLoadFailed": "Échec du chargement de cette image pour la modifier",
    "gallery.cannotAddImage": "Cette image ne peut pas être ajoutée à la galerie",
    "gallery.nameRequired": "Entrez un nom de galerie",
    "gallery.saveFailed": "Échec de l'enregistrement de l'image de la galerie",
    "gallery.savedAsReference": "Ajouté à la galerie et basculé vers la référence de la galerie",
    "gallery.renameImage": "Renommer l'image de la galerie",
    "gallery.moveToCategory": "Passer à la catégorie",
    "gallery.categoryRequired": "Choisissez une catégorie de galerie",
    "gallery.promptNoteTitle": "Note de référence de la galerie",
    "gallery.updateFailed": "Échec de la mise à jour de la galerie",
    "gallery.selectImageFile": "Choisissez un fichier image",
    "gallery.replaceImageFailed": "Échec du remplacement de l'image de la galerie",
    "gallery.replacedImage": "Remplacement de l'image source pour \"{name}\"",
    "gallery.deleteImageTitle": "Supprimer l'image de la galerie?",
    "gallery.deleteImageMessage": "Les références de tâches historiques s’afficheront comme supprimées.",
    "gallery.deleteFailed": "Échec de la suppression de l'image de la galerie",
    "gallery.deletedSuffix": "(supprimé)",
    "gallery.editImageLabel": "Modifier l'image de la galerie",
    "gallery.fieldCategory": "Catégorie",
    "gallery.fieldPromptNote": "Note de référence",
    "gallery.fieldName": "Nom",
    "quickGallery.empty": "Aucune image {category}",
    "promptGallery.remove": "Supprimer @{name}",
    "prompt.title": "Invite",
    "prompt.editorLabel": "Invite",
    "prompt.placeholder": "Décrivez l'image que vous souhaitez générer ou modifier. Tapez @ pour les références de galerie, # pour les codes de couleur et ~ pour les extraits d'invite.",
    "prompt.run": "Générer",
    "prompt.runEdit": "Commencer l'édition",
    "prompt.runTitle": "Générer (Cmd+Enter)",
    "prompt.runEditTitle": "Commencer la modification (Cmd+Enter)",
    "prompt.findPanel": "Invite de recherche et de remplacement",
    "prompt.findText": "Rechercher du texte",
    "prompt.replaceWith": "Remplacer par",
    "prompt.findActions": "Rechercher et remplacer des actions",
    "prompt.countZero": "0 correspondances",
    "prompt.matchCount": "{count} correspond",
    "prompt.foundCount": "Correspondances {count} trouvées",
    "prompt.noMatch": "Aucun texte correspondant",
    "prompt.replacedCount": "Remplacement des correspondances {count}",
    "prompt.closeFind": "Fermer Rechercher et remplacer",
    "prompt.recentTemplates": "Modèles récents",
    "prompt.manageTemplates": "Gérer les modèles",
    "promptModel.galleryHeader": "Remarques sur l'image de référence:",
    "promptModel.galleryInstruction": "- Image de référence {number}: galerie \"{name}\", rôle: {role}. @{name} dans l'invite fait référence à cette image.{note}",
    "outputSettings.title": "Sortie",
    "output.lock.lock": "Verrouiller les paramètres",
    "output.lock.unlock": "Déverrouiller et modifier",
    "output.lock.current": "Verrouillage actuel",
    "output.lock.task": "Paramètres de la tâche",
    "output.lock.adoptTask": "Utiliser les paramètres de cette tâche",
    "output.lock.frame": "Cadrage",
    "output.lock.outputCount": "Nombre de sorties",
    "output.lock.output": "Sortie",
"output.lock.search": "Recherche",
    "output.lock.call": "Appel",
    "output.lock.sheets": "images",
    "output.lock.imageModel": "Modèle d’image",
    "output.lock.prompt": "Prompt",
    "output.lock.fileFormat": "Format de fichier",
    "output.lock.taskHint": "Seuls les paramètres de la tâche sont affichés ; le verrouillage actuel reste inchangé. Leur utilisation ne change pas le canal système.",
    "output.lock.lockedHint": "Les paramètres sont fixés. Utilisez le cadenas en haut à droite pour les modifier.",
    "output.lock.enabled": "Activée",
    "output.lock.disabled": "Désactivée",
    "output.mainModel": "Modèle principal",
    "output.selectMainModel": "Sélectionnez le modèle principal",
    "output.mainModelCustomForInput": "Utiliser un modèle personnalisé pour l'entrée actuelle",
    "output.apiDirect": "API Direct",
    "output.apiToolModel": "Utilisation du modèle de génération d’images API",
    "output.mainModelUnused": "Le modèle principal n'est pas utilisé pour cette demande",
    "output.webSearch": "Recherche sur le Web",
    "output.webSearchToggle": "Sur",
    "output.webSearchTitle": "Recherchez d'abord sur le Web, puis utilisez-le pour cette génération; Codex et API Responses uniquement",
    "output.promptMode": "Traitement du prompt",
    "output.modeOriginal": "Original",
    "output.modeStrict": "Fidèle",
    "output.modeCreative": "Automatique",
    "output.promptHelp": "Expliquer le traitement du prompt",
    "output.promptHelpTitle": "Traitement du prompt",
    "output.promptHelp.responsesChannel": "Responses · modèle principal impliqué",
    "output.promptHelp.imagesChannel": "Images · génération directe",
    "output.promptHelp.responses.original": "Envoie le texte original au modèle principal et demande à l’outil d’image de le conserver ; un revised prompt peut malgré tout être produit.",
    "output.promptHelp.responses.strict": "Autorise le modèle principal à organiser ou développer le prompt tout en préservant les contraintes de sujet, texte, couleur et composition.",
    "output.promptHelp.responses.automatic": "N’ajoute aucune contrainte ; le modèle principal interprète et optimise avant d’appeler l’outil d’image.",
    "output.promptHelp.images.original": "N’ajoute aucune règle applicative et envoie le texte original directement à l’API d’images.",
    "output.promptHelp.images.strict": "Envoie les règles de fidélité avec le prompt original afin de préserver toutes les contraintes.",
    "output.promptHelp.images.automatic": "Utilise le traitement par défaut de l’API d’images et conserve les notes nécessaires pour les références de galerie.",
    "output.sizeMode": "Mode taille",
    "output.sizePreset": "Préréglage",
    "output.sizeCustom": "Personnalisé",
    "output.orientation": "Orientation",
    "output.square": "Carré",
    "output.portrait": "Portrait",
    "output.landscape": "Paysage",
    "output.resolution": "Résolution",
    "output.pixelSize": "Taille des pixels",
    "output.width": "Largeur",
    "output.height": "Hauteur",
    "output.swapSize": "Intervertir la largeur et la hauteur",
    "output.customSizeHint": "Unité px · 16-3840 · multiple de 16 · ≤3:1",
    "output.imageSizeUnavailable": "Taille de l'image indisponible",
    "output.imageLoadFailed": "L'image n'a pas pu être chargée",
    "output.customSizeRequired": "Entrez la largeur et la hauteur",
    "output.customSizeBounds": "La largeur et la hauteur doivent être comprises entre 16 et 3 840 px.",
    "output.customSizeMultiple": "La largeur et la hauteur doivent être des multiples de 16",
    "output.customSizeRatio": "Le rapport des côtés longs/courts ne peut pas dépasser 3:1.",
    "output.customSizePixels": "Le nombre total de pixels doit être compris entre 655 360 et 8 294 400.",
    "output.ratioLock": "Verrouillage du rapport (en option)",
    "output.customRatio": "Rapport hauteur/largeur personnalisé",
    "output.ratioWidth": "W",
    "output.ratioHeight": "H",
    "output.firstImageRatio": "Utiliser le premier rapport hauteur/largeur de l'image de référence",
    "output.useFirstImage": "À partir de l'image",
    "output.ratioHint": "Laissez vide pour la taille libre · Remplissez les deux pour synchroniser",
    "output.ratio": "Rapport",
    "output.quality": "Qualité",
    "output.qualityAuto": "Automatique",
    "output.qualityLow": "Faible",
    "output.qualityMedium": "Moyen",
    "output.qualityHigh": "Élevé",
    "output.quantity": "Compter",
    "output.pixelPreview": "Pixels de sortie: 1024 x 1024 px",
    "output.pixelPreviewValue": "Pixels de sortie: {value}",
    "output.pixelPreviewAuto": "Pixels de sortie: auto (OpenAI choisit automatiquement)",
    "output.format": "Formater",
    "output.compression": "Compression",
    "output.moderation": "Modération",
    "preview.title": "Aperçu",
    "preview.selectedZero": "0 sélectionné",
    "preview.selectedCount": "Sélectionné {selected}/{total}",
    "preview.downloadSelected": "Télécharger sélectionné",
    "preview.deleteUnselected": "Supprimer les éléments non sélectionnés",
    "preview.downloadAll": "Télécharger ZIP",
    "preview.empty": "Aucune image pour l'instant",
    "preview.taskFailed": "La tâche a échoué",
    "preview.partialFailed": "Certaines images ont échoué",
    "preview.failedOutput": "L'image {index} a échoué",
    "preview.progressLine": "Terminé {generated} / {total} · écoulé {elapsed}",
    "preview.failureLine": "Terminé {generated} / {total} · échoué {failed}",
    "preview.elapsedLine": "{elapsed} écoulé",
    "preview.lastError": "Dernière erreur: {error}",
    "preview.continueGenerating": "Génération continue",
    "preview.waitingContinue": "En attendant de continuer",
    "preview.retryFailed": "Réessayer les images ayant échoué",
    "preview.acceptSuccesses": "Acceptez les résultats positifs",
    "preview.generateMode": "Génération",
    "preview.editMode": "Modifier",
    "preview.runningTitle": "{mode} en cours d'exécution",
    "preview.submittingTitle": "Soumission de la tâche",
    "preview.queuedTitle": "Tâche en file d'attente",
    "preview.submittingDetail": "Sauvegarde des entrées et ajout de la tâche à la file d'attente. La génération démarrera automatiquement.",
    "preview.queuedDetail": "La tâche est dans la file d'attente et attend un canal disponible.",
    "preview.featured": "Sélectionné",
    "preview.addFeatured": "Sélectionner le résultat",
    "preview.selectedFeatured": "Sélectionné",
    "preview.removeFeatured": "Désélectionner le résultat",
    "preview.selectionAdded": "Résultat sélectionné",
    "preview.selectionRemoved": "Résultat désélectionné",
    "preview.selectionUpdateFailed": "Échec de la mise à jour de la sélection",
    "preview.noUnselectedOutputs": "Aucune image non sélectionnée à supprimer",
    "preview.deleteUnselectedTitle": "Supprimer les images non sélectionnées?",
    "preview.deleteUnselectedMessage": "Cela supprimera les fichiers image locaux pour les résultats non sélectionnés dans cette tâche.",
    "preview.deleteUnselectedDetail": "Conserver {selected}, supprimer {deleted}",
    "preview.deleteUnselectedFailed": "Échec de la suppression des images non sélectionnées",
    "preview.deleteUnselectedDone": "Images non sélectionnées supprimées",
    "preview.addReference": "Ajouter une référence",
    "preview.stage": "Scène",
    "preview.stageReference": "Étape comme référence en attente",
    "preview.prompt": "Invite",
    "preview.download": "Télécharger",
    "preview.downloadImage": "Téléchargez cette image",
    "lightbox.label": "Aperçu de l'image",
    "lightbox.close": "Fermer l'aperçu",
    "lightbox.previous": "Image précédente",
    "lightbox.next": "Image suivante",
    "promptPopover.title": "Comparaison rapide",
    "promptPopover.summary": "Original {original} · optimisé {optimized}",
    "promptPopover.original": "Invite d'origine",
    "promptPopover.optimized": "Invite optimisée",
    "promptPopover.charCount": "{count} caractères",
    "promptPopover.empty": "Aucun",
    "promptPopover.notReturned": "Non retourné",
    "promptPopover.noOptimized": "Aucune invite optimisée renvoyée",
    "promptPopover.submitted": "Afficher l'invite soumise",
    "promptPopover.close": "Fermer la comparaison rapide",
    "promptPopover.copyOptimized": "Copier l'invite optimisée",
    "promptPopover.copied": "Copié",
    "taskContext.menuLabel": "Menu contextuel de la tâche",
    "taskContext.view": "Afficher la tâche",
    "taskContext.copyId": "Copier la tâche ID",
    "taskContext.copyPrompt": "Copier l'invite",
    "taskContext.revealOutput": "Ouvrir le dossier de sortie",
    "taskContext.archive": "Tâche d'archivage",
    "taskContext.delete": "Supprimer la tâche",
    "taskContext.idCopied": "Tâche ID copiée",
    "taskContext.promptCopied": "Invite copiée",
    "taskContext.noPrompt": "Cette tâche n'est pas invitée à copier",
    "taskContext.revealFailed": "Échec de l'ouverture du dossier de sortie",
    "taskContext.revealOpened": "Dossier de sortie ouvert",
    "taskContext.actionFailed": "L'action de la tâche a échoué",
    "taskActions.group": "Actions de tâche",
    "taskActions.deleteTitle": "Supprimer la tâche?",
    "taskActions.deleteMessage": "Cela supprimera également les fichiers image locaux.",
    "taskActions.runningCannotDelete": "Les tâches en cours ne peuvent pas être supprimées",
    "taskActions.updated": "Statut de la tâche mis à jour",
    "taskActions.archived": "Discussion archivée",
    "taskActions.archiveFailed": "L'archivage a échoué",
    "taskActions.deleted": "Tâche supprimée",
    "taskActions.deleteFailed": "Échec de la suppression",
    "taskActions.noRetryableFailedImages": "Cette tâche n'a aucune image ayant échoué à réessayer",
    "taskActions.retryFailedOutputsFailed": "Échec de la nouvelle tentative des images ayant échoué",
    "taskActions.requeuedFailedImages": "Images échouées remises en file d'attente",
    "taskActions.noAcceptableSuccessImages": "Cette tâche n'a aucune image réussie à accepter",
    "taskActions.acceptSuccessesFailed": "Échec de l'acceptation des résultats positifs",
    "taskActions.acceptedSuccesses": "Résultats réussis acceptés",
    "taskActions.viewedUpdateFailed": "Échec de la mise à jour de l'état de lecture",
    "taskActions.failedFallback": "La tâche a échoué",
    "taskList.empty": "Pas encore d'historique",
    "taskList.selectSession": "Sélectionnez le chat",
    "taskList.unreadUpdate": "Mise à jour non lue",
    "taskList.viewing": "Affichage",
    "taskDerived.usageLimited": "Utilisation limitée",
    "taskSubmit.requestFailed": "La demande a échoué",
    "taskSubmit.queued": "Tâche ajoutée à la file d'attente",
    "taskSubmit.timeout": "Le délai de soumission de la tâche a expiré avant que le backend ne réponde. Actualisez la file d'attente pour confirmer si elle a été ajoutée, puis décidez si vous souhaitez réessayer.",
    "taskSubmit.failed": "Échec de la soumission de la tâche",
    "templates.title": "Modèles d'invite",
    "templates.summary": "Bibliothèque de modèles locale",
    "templates.availableCount": "{count} modèles disponibles",
    "templates.noMatch": "Aucun modèle correspondant",
    "templates.empty": "Aucun modèle",
    "templates.favoriteBadge": "Favoris",
    "templates.usageCount": "{count} utilise",
    "templates.back": "Retour",
    "templates.edit": "Modifier",
    "templates.copy": "Copier",
    "templates.insert": "Insérer",
    "templates.formTitle": "Titre",
    "templates.formShortTitle": "Titre court",
    "templates.formCategory": "Catégorie",
    "templates.formTags": "Balises",
    "templates.formThumbnail": "Miniature",
    "templates.formContent": "Contenu",
    "templates.formNotes": "Remarques",
    "templates.formFavorite": "Favoris",
    "templates.thumbnailClear": "Effacer",
    "templates.thumbnailNone": "Aucun sélectionné",
    "templates.thumbnailEmpty": "Aucune vignette d'historique",
    "templates.newCategory": "Nouvelle catégorie",
    "templates.search": "Rechercher des modèles, des balises ou du contenu",
    "templates.filter": "Filtres de modèles",
    "templates.all": "Tout",
    "templates.categoryCommon": "Commun",
    "templates.categoryPortrait": "Portrait",
    "templates.categoryProduct": "Produit",
    "templates.categoryRepair": "Réparation",
    "templates.categoryPoster": "Affiche",
    "templates.categoryEcommerce": "Commerce électronique",
    "templates.favorite": "Favoris",
    "templates.recent": "Récent",
    "templates.category": "Catégories",
    "templates.loadFailed": "Échec du chargement des modèles d'invite",
    "templates.useStateUpdateFailed": "Échec de la mise à jour de l'état d'utilisation du modèle d'invite",
    "templates.copied": "Modèle d'invite copié",
    "templates.copyFailed": "Échec de la copie du modèle d'invite",
    "templates.history": "Histoire",
    "templates.saveFailed": "Échec de l'enregistrement du modèle d'invite",
    "templates.saved": "Modèle d'invite enregistré",
    "templates.deleteFailed": "Échec de la suppression du modèle d'invite",
    "templates.deleted": "Modèle d'invite supprimé",
    "templates.categoryAddFailed": "Échec de l'ajout d'une catégorie de modèle",
    "templates.categoryAdded": "Catégorie de modèle ajoutée",
    "templates.categorySaveFailed": "Échec de l'enregistrement de la catégorie de modèle",
    "templates.categorySaved": "Catégorie de modèle enregistrée",
    "templates.categoryDeleteFailed": "Échec de la suppression de la catégorie de modèle",
    "templates.categoryDeleted": "Catégorie de modèle supprimée",
    "templates.importFailed": "Échec de l'importation du pack de modèles",
    "templates.importedCount": "Modèles {count} importés",
    "templates.exportFailed": "Échec de l'exportation du pack de modèles",
    "templates.exported": "Pack de modèles exporté",
    "snippets.suggestLabel": "Sélecteur d'extraits de code rapide",
    "snippets.saveSelection": "Enregistrer",
    "snippets.saveSelectionLabel": "Enregistrer le texte sélectionné sous forme d'extrait d'invite",
    "snippets.popoverLabel": "Extrait d'invite",
    "snippets.defaultCategory": "Commun",
    "snippets.loadFailed": "Échec du chargement des extraits d'invite",
    "snippets.remove": "Supprimer ~{tag}",
    "snippets.expand": "Développer",
    "snippets.edit": "Modifier",
    "snippets.close": "Fermer",
    "snippets.editTitle": "Modifier l'extrait",
    "snippets.saveTitle": "Enregistrer l'extrait",
    "snippets.shortTag": "Balise courte",
    "snippets.title": "Titre",
    "snippets.category": "Catégorie",
    "snippets.content": "Contenu",
    "snippets.titlePlaceholder": "Utilise la balise courte par défaut",
    "snippets.cancel": "Annuler",
    "snippets.save": "Enregistrer",
    "snippets.saveFailed": "Échec de l'enregistrement de l'extrait d'invite",
    "snippets.saved": "Extrait d'invite enregistré",
    "snippets.defaultTag": "Extrait commun",
    "colors.white": "Blanc",
    "colors.black": "Noir",
    "colors.warmBeige": "Beige chaud",
    "colors.lightGreen": "Vert clair",
    "colors.brandGreen": "Marque verte",
    "colors.peachOrange": "Orange pêche",
    "colors.lightBlue": "Bleu clair",
    "colors.lightPink": "Rose clair",
    "colors.loadFailed": "Échec du chargement des paramètres de couleur",
    "colors.saveFailed": "Échec de l'enregistrement des paramètres de couleur",
    "colors.importFailed": "Échec de l'importation des paramètres de couleur",
    "colors.importedCount": "Couleurs {count} importées",
    "colors.recentSaveFailed": "Échec de l'enregistrement des couleurs récentes",
    "colors.favoriteSaveFailed": "Échec de l'enregistrement de la couleur préférée",
    "colors.favoriteDeleteFailed": "Échec de la suppression de la couleur préférée",
    "colors.update": "Mise à jour",
    "colors.insert": "Insérer",
    "colors.pick": "Choisissez la couleur",
    "colors.pickShort": "Choisir",
    "colors.hexValue": "Valeur de couleur",
    "colors.pendingUpdate": "La couleur a changé. Cliquez sur Mettre à jour pour postuler.",
    "colors.save": "Enregistrer",
    "colors.exportPs": "Exporter",
    "colors.importPs": "Importer",
    "colors.done": "Terminé",
    "colors.manage": "Gérer",
    "colors.favorites": "Couleurs préférées",
    "colors.recent": "Couleurs récentes",
    "colors.recentLabel": "Récent",
    "colors.deleteFavorite": "Supprimer la couleur préférée {name}",
    "colors.modify": "Modifier la couleur",
    "colors.modifyValue": "Modifier la couleur {value}",
    "colors.removeValue": "Supprimer la couleur {value}",
    "taskGroup.today": "Aujourd'hui",
    "taskGroup.yesterday": "Hier",
    "taskGroup.last7": "7 derniers jours",
    "taskGroup.older": "Plus âgé",
    "taskGroup.searchResults": "Résultats de la recherche",
    "taskGroup.active": "Actif",
    "taskGroup.running": "Courir",
    "taskGroup.waiting": "En attente",
    "taskGroup.dispatchPending": "Attribution d'un canal disponible...",
    "taskGroup.expand": "Développez {label}",
    "taskGroup.collapse": "Réduire {label}",
    "taskGroup.buttonLabel": "Tâches {label}, {count}",
    "archive.title": "Archiver",
    "archive.empty": "Aucune discussion archivée",
    "archive.count": "{count} discussions archivées",
    "archive.restore": "Restaurer",
    "archive.archiveFailed": "L'archivage a échoué",
    "archive.restoreFailed": "La restauration a échoué",
    "archive.restored": "Chat restauré",
    "archive.archiving": "Archivage...",
    "archive.restoring": "Restauration...",
    "archive.deleting": "Suppression...",
    "archive.restoredCount": "Tâches {count} restaurées",
    "settings.title": "Stockage",
    "settings.status": "Redémarrez WebUI après avoir enregistré les chemins de stockage",
    "settings.inputRoot": "Dossier d'entrée",
    "settings.outputRoot": "Dossier de sortie",
    "settings.galleryRoot": "Dossier Galerie",
    "settings.sourceDataRoot": "Dossier de données sources",
    "settings.language": "Langue de l'interface",
    "settings.languageCopy": "Au premier lancement, l'interface suit la langue de votre navigateur. Les choix manuels sont mémorisés.",
    "settings.notificationsCopy": "Avertissez lorsque les tâches se terminent ou échouent. Les notifications système doivent être activées manuellement.",
    "settings.inAppNotification": "Notifications dans l'application",
    "settings.systemNotification": "Notifications système",
    "settings.save": "Enregistrer les paramètres",
    "settings.loadFailed": "Échec du chargement des paramètres",
    "settings.saveFailed": "Échec de l'enregistrement des paramètres",
    "settings.savedRestart": "Paramètres de stockage enregistrés. Redémarrez WebUI pour appliquer.",
    "settings.saved": "Enregistré",
    "settings.savedRestartStatus": "Paramètres de stockage enregistrés. Redémarrez WebUI pour appliquer.",
    "systemSettings.title": "Paramètres système",
    "systemSettings.tabsLabel": "Sections des paramètres système",
    "systemSettings.apiTab": "API Paramètres",
    "systemSettings.codexTab": "Canal Codex",
    "systemSettings.languageTab": "Langue / Language",
    "systemSettings.storageTab": "Stockage et notifications",
    "languageSettings.instantStatus": "Les changements de langue s'appliquent immédiatement",
    "apiSettings.title": "API Paramètres",
    "apiSettings.status": "Les paramètres enregistrés s'appliquent immédiatement en mode API",
    "apiSettings.codexMode": "Canal Codex",
    "apiSettings.codexImages": "Image",
    "apiSettings.codexResponses": "Responses",
    "apiSettings.providers": "Fournisseurs API",
    "apiSettings.searchProviders": "Rechercher un fournisseur",
    "apiSettings.noProviderSearchResults": "Aucun fournisseur correspondant",
    "apiSettings.providerCount": "Fournisseurs {count}",
    "apiSettings.provider": "Fournisseur",
    "apiSettings.providerName": "Nom du fournisseur",
    "apiSettings.actualRequest": "Requête effective",
    "apiSettings.newProviderAction": "Nouveau fournisseur",
    "apiSettings.copyProvider": "Copier",
    "apiSettings.copyProviderName": "{name} Copie",
    "apiSettings.copyProviderStatus": "Fournisseur copié avec sa clé enregistrée. Modifiez le nom, le modèle ou remplacez la clé avant de sauvegarder.",
    "apiSettings.copyProviderWithoutKeyStatus": "Fournisseur copié. Modifiez le nom, le modèle ou ajoutez une clé API avant d'enregistrer.",
    "apiSettings.sortProviders": "Trier",
    "apiSettings.finishSortProviders": "Terminé",
    "apiSettings.sortProviderModeStatus": "Fournisseurs de tri",
    "apiSettings.sortProviderStatus": "L'ordre des fournisseurs a été modifié. Enregistrement automatique...",
    "apiSettings.moveProviderUp": "Vers le haut",
    "apiSettings.moveProviderDown": "Vers le bas",
    "apiSettings.moveProviderUpAria": "Déplacer {provider} vers le haut",
    "apiSettings.moveProviderDownAria": "Déplacer {provider} vers le bas",
    "apiSettings.mode": "Mode demande",
    "apiSettings.images": "Image directe API",
    "apiSettings.responses": "Responses API",
    "apiSettings.modeImagesShort": "Direct",
    "apiSettings.imageModel": "Modèle de génération d’images",
    "apiSettings.concurrency": "Limite de simultanéité",
    "apiSettings.concurrencyShort": "Concurrence",
    "apiSettings.advancedSettings": "Paramètres avancés",
    "apiSettings.concurrencyValue": "concurrence {concurrency}",
    "apiSettings.keySaved": "Clé API enregistrée",
    "apiSettings.keyNotSet": "Clé API non définie",
    "apiSettings.showApiKey": "Afficher la clé API",
    "apiSettings.hideApiKey": "Masquer la clé API",
    "apiSettings.editProvider": "Modifier le fournisseur",
    "apiSettings.newProviderTitle": "Nouveau fournisseur",
    "apiSettings.editHint": "Le fournisseur de sauvegarde écrit cette modification dans le backend. Annuler le supprime.",
    "apiSettings.finishEditFirst": "Enregistrez ou annulez d'abord la modification du fournisseur actuel",
    "apiSettings.newDraftStatus": "Création d'un fournisseur. Enregistrez le fournisseur pour postuler.",
    "apiSettings.editDraftStatus": "Fournisseur d'édition. Enregistrez le fournisseur pour postuler.",
    "apiSettings.cancelEdit": "Annuler la modification",
    "apiSettings.saveProvider": "Enregistrer le fournisseur",
    "apiSettings.saveSelection": "Enregistrer la sélection",
    "apiSettings.deleteProviderTitle": "Supprimer le fournisseur?",
    "apiSettings.deleteProviderMessage": "Supprimer « {provider} »?",
    "apiSettings.deleteProviderDetail": "Cela le supprime de la liste des fournisseurs et l'enregistre automatiquement dans le backend.",
    "apiSettings.deleteProviderStatus": "Fournisseur supprimé. Enregistrement automatique...",
    "apiSettings.save": "Enregistrer les paramètres API",
    "apiSettings.loadFailed": "Échec du chargement des paramètres API",
    "apiSettings.savedKeyPlaceholder": "La clé API est enregistrée sur le backend. Entrez une nouvelle clé pour la remplacer.",
    "apiSettings.newProvider": "Nouveau fournisseur",
    "apiSettings.saving": "Sauvegarde...",
    "apiSettings.savingStatus": "Enregistrement des paramètres API...",
    "apiSettings.autoSaving": "Enregistrement automatique...",
    "apiSettings.autoSaved": "Enregistré automatiquement",
    "apiSettings.saveFailed": "Échec de l'enregistrement des paramètres API",
    "apiSettings.savedSummary": "Enregistré · Codex {codex} · API {provider} · {mode} · {model} · simultanéité {concurrency}",
    "apiSettings.savedShort": "Enregistré",
    "apiSettings.savedStatus": "Paramètres API enregistrés",
    "apiSettings.saveFailedShort": "Échec de l'enregistrement",
    "codexSettings.title": "Canal Codex",
    "codexSettings.status": "Choisissez le canal de génération pour la connexion locale Codex",
    "codexSettings.notesLabel": "Notes de la chaîne Codex",
    "codexSettings.imagesTitle": "Codex Image",
    "codexSettings.imagesCopy": "Canal par défaut pour transmettre directement les paramètres de taille, de qualité et d’édition.",
    "codexSettings.responsesTitle": "Codex Responses",
    "codexSettings.responsesCopy": "Canal de compatibilité pour les flux de travail nécessitant des outils de recherche Web.",
    "codexSettings.current": "Actuel",
    "codexSettings.save": "Enregistrer la chaîne Codex",
    "codexSettings.saveMode": "Enregistrer {mode}",
    "imageEditor.title": "Modifier l'image d'entrée",
    "imageEditor.promptHint": "Les flèches et les marques dessinées à la main dans l'image ne sont que des instructions. Ne les conservez pas dans l'image finale.",
    "imageEditor.inputFallback": "Image d'entrée",
    "imageEditor.openFailed": "Échec de l'ouverture de cette image pour la modifier",
    "imageEditor.loadForEditFailed": "Échec du chargement de cette image pour la modifier",
    "imageEditor.canvasCreateFailed": "Échec de la création du canevas d'édition d'image",
    "imageEditor.closedRegionRequired": "Utilisez le pinceau pour dessiner d'abord une région fermée",
    "imageEditor.saveFailed": "Échec de l'enregistrement de la modification de l'image",
    "imageEditor.saved": "Image d'entrée modifiée enregistrée",
    "imageEditor.uneditable": "Cette image ne peut pas être modifiée",
    "imageEditor.resetDone": "Réinitialiser à l'image d'origine",
    "imageEditor.resetFailed": "Échec de la réinitialisation de l'image d'origine",
    "imageEditor.subtitle": "Recadrez, dessinez, remplissez ou ajoutez des flèches, puis enregistrez en tant que nouvelle image d'entrée",
    "imageEditor.toolbar": "Barre d'outils de l'éditeur d'images",
    "imageEditor.tools": "Outils",
    "imageEditor.select": "Sélectionner",
    "imageEditor.brush": "Brosse",
    "imageEditor.arrow": "Flèche",
    "imageEditor.crop": "Recadrer",
    "imageEditor.fill": "Remplir",
    "imageEditor.fillLabel": "Remplissage du pot de peinture",
    "imageEditor.eraser": "Gomme",
    "imageEditor.colors": "Couleurs",
    "imageEditor.red": "Rouge",
    "imageEditor.blue": "Bleu",
    "imageEditor.green": "Vert",
    "imageEditor.yellow": "Jaune",
    "imageEditor.white": "Blanc",
    "imageEditor.black": "Noir",
    "imageEditor.customColor": "Couleur personnalisée",
    "imageEditor.stroke": "Accident vasculaire cérébral",
    "imageEditor.history": "Histoire",
    "imageEditor.undo": "Annuler",
    "imageEditor.redo": "Refaire",
    "imageEditor.reset": "Réinitialiser l'image",
    "imageEditor.canvas": "Toile d'édition d'images",
    "imageEditor.canvasScope": "Zone du canevas",
    "imageEditor.canvasScopeBase": "Image de base",
    "imageEditor.canvasScopeFit": "Ajuster aux calques",
    "imageEditor.canvasFitDone": "Canevas ajusté à la zone des calques",
    "imageEditor.canvasBaseDone": "Canevas rétabli sur l'image de base",
    "imageEditor.insertImages": "Insérer des images",
    "imageEditor.layers": "Calques",
    "imageEditor.layerUp": "Monter",
    "imageEditor.layerDown": "Descendre",
    "imageEditor.emptyInsertList": "Aucune autre image d'entrée",
    "imageEditor.selectLayerFirst": "Sélectionnez d'abord un calque",
    "imageEditor.baseLayer": "Image de base",
    "gallery.title": "Galerie",
    "gallery.subtitle": "Choisir des images de référence pour la tâche en cours",
    "gallery.manageCategories": "Gérer les catégories",
    "gallery.categoryManager": "Gérer les catégories de la galerie",
    "gallery.categoryManagement": "Gestion des catégories",
    "gallery.categoryCopy": "Les catégories sont enregistrées dans la galerie; les rôles d'invite décrivent comment les références sont utilisées.",
    "gallery.newCategoryName": "Nouveau nom de catégorie",
    "gallery.newCategoryRole": "Rôle d'invite, par ex. référence de style",
    "gallery.addCategory": "Ajouter une catégorie",
    "gallery.drawerSubtitle": "Catégorie actuelle: {category}. Cliquez sur \"Utiliser\" pour l'ajouter à l'entrée d'image.",
    "gallery.emptyCategory": "Aucune image dans cette catégorie pour l'instant",
    "gallery.dragSort": "Faites glisser pour trier",
    "gallery.dragSortImage": "Image par glisser-trier {name}",
    "gallery.dragSortCategory": "Catégorie de tri par glisser-déposer {name}",
    "gallery.use": "Utiliser",
    "gallery.replace": "Remplacer",
    "gallery.rename": "Renommer",
    "gallery.moveCategory": "Catégorie",
    "gallery.note": "Remarque",
    "gallery.delete": "Supprimer",
    "gallery.uncategorized": "Non classé",
    "addGallery.title": "Ajouter à la galerie",
    "addGallery.copy": "Les noms sont uniques au monde et peuvent être référencés avec @name ultérieurement.",
    "addGallery.name": "Nom",
    "addGallery.namePlaceholder": "Exemple: Mia",
    "addGallery.category": "Catégorie",
    "addGallery.note": "Note de référence",
    "addGallery.notePlaceholder": "Exemple: référence au visage et aux cheveux uniquement, pas aux vêtements ni à l'arrière-plan",
    "addGallery.save": "Enregistrer dans la galerie",
    "close.promptTemplates": "Fermer le panneau des modèles d'invite",
    "close.archive": "Fermer le panneau d'archives",
    "close.settings": "Fermer le panneau des paramètres de stockage",
    "close.apiSettings": "Fermez le panneau de paramètres API",
    "close.systemSettings": "Fermer le panneau des paramètres système",
    "close.imageEditor": "Fermer le panneau de l'éditeur d'images",
    "close.gallery": "Fermer le panneau de la galerie",
    "close.addGallery": "Fermer le panneau Ajouter à la galerie",
    "close.version": "Fermer le panneau de mise à jour de la version",
    "imageInput.referenceTitle": "Entrée de référence (facultative)",
    "referenceFiles.add": "Ajouter un fichier",
    "referenceFiles.selected": "Fichiers de référence",
    "referenceFiles.recent": "Fichiers récents",
    "referenceFiles.familyPdf": "Pages + texte",
    "referenceFiles.familySpreadsheet": "Tableur",
    "referenceFiles.familyDocument": "Document",
    "referenceFiles.familyText": "Texte",
    "referenceFiles.visualLimit": "Les fichiers non PDF ne conservent pas les images et graphiques intégrés. Convertissez en PDF si la mise en page compte.",
    "referenceFiles.remove": "Supprimer {filename}",
    "referenceFiles.switchTitle": "Supprimer les fichiers de référence ?",
    "referenceFiles.switchMessage": "Les fichiers de référence fonctionnent uniquement avec Responses. Supprimez-les avant de passer à Images.",
    "referenceFiles.removeAndSwitch": "Supprimer et changer",
    "referenceFiles.requiresResponses": "Les fichiers de référence nécessitent Responses",
    "referenceFiles.switchToResponses": "Passer à Responses",
    "referenceFiles.openApiSettings": "Ouvrir les paramètres API",
    "referenceFiles.providerMissing": "Le fournisseur Responses d’origine est indisponible. Choisissez-en un dans les paramètres API.",
    "referenceFiles.missing": "Fichier manquant",
    "referenceFiles.loadFailed": "Échec du chargement des fichiers de référence",
    "referenceFiles.errorEmpty": "Le fichier de référence est vide",
    "referenceFiles.errorUnsupported": "Ce type de fichier de référence n’est pas pris en charge",
    "referenceFiles.errorMismatch": "Le contenu ne correspond pas à l’extension",
    "referenceFiles.errorInvalid": "Le fichier de référence est invalide",
    "referenceFiles.errorTooLarge": "Chaque fichier de référence doit faire moins de 50 Mo",
    "referenceFiles.errorTotalTooLarge": "Les fichiers de référence ne peuvent pas dépasser 50 Mo au total",
    "referenceFiles.errorMissing": "Un fichier de référence sélectionné est manquant",
    "referenceFiles.errorProviderUnsupported": "Responses de ce fournisseur ne prend pas en charge les fichiers de référence",
    "referenceFiles.responsesEnabled": "Responses activé",
    "referenceFiles.historyPathMismatch": "Ces fichiers utilisent des chemins Responses différents",
    "history.referenceFiles": "Fichiers de référence",
    "history.downloadReferenceFile": "Télécharger le fichier",
    "history.readdReferenceFile": "Ajouter à nouveau",
};
